import styled from '@emotion/styled';

export const Icon = styled.i<{ 'data-size'?: 'string'; }>`
    font-style: normal;
    font-family: 'OutlineEmoji';
    ${props => props['data-size'] ? `font-size: ${props['data-size']};` : ''}
`;